export function createAndDispatchCustomEvent(eventName: string, params?: any) {
  const newCustomEvent = params ? new CustomEvent(eventName, { detail: params }) : new CustomEvent(eventName);
  window.dispatchEvent(newCustomEvent);
}
